import React from 'react';
import { Typography } from "@mui/material";
import { useEnums } from '../hooks/useEnums';

const TexturePreference = ({ selectedTextures = [], setSelectedTextures, title }) => {
  const enums = useEnums();

  // Make sure we have an array of texture values
  const safeSelectedTextures = Array.isArray(selectedTextures) ? selectedTextures : [];

  // Debug info
  console.log(`TexturePreference (${title}) received selectedTextures:`, safeSelectedTextures);

  const toggleTexture = (textureValue) => {
    if (!setSelectedTextures) {
      console.log(`No setSelectedTextures function provided to ${title}`);
      return;
    }

    // Log the current state and the change being made
    console.log(`TexturePreference (${title}) toggling ${textureValue}`);
    console.log(`Current selection:`, safeSelectedTextures);

    // Calculate new state
    const newSelection = safeSelectedTextures.includes(textureValue)
      ? safeSelectedTextures.filter(value => value !== textureValue)
      : [...safeSelectedTextures, textureValue];

    console.log(`New selection will be:`, newSelection);

    // Update state
    setSelectedTextures(newSelection);
  };

  return (
    <div className="texture-preference-container">
      <Typography variant="h6" gutterBottom className="section-title">
        {title}
      </Typography>
      {Object.entries(enums.textureGroups || {}).map(([group, textures]) => (
        <div key={group} className="texture-group">
          <Typography variant="subtitle2" sx={{ mt: 1, mb: 0.5, fontSize: '0.85rem', color: '#666' }}>
            {group}
          </Typography>
          <div className="texture-selection">
            {[...textures].sort().map((texture) => {
              const isSelected = safeSelectedTextures.includes(texture);

              return (
                <div
                  key={`${title}-${texture}`}
                  className={`texture-option ${isSelected ? "selected" : ""}`}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    toggleTexture(texture);
                  }}
                >
                  <div className="texture-container">
                    <div className="texture-label-container">
                      <span className="texture-label">
                        {texture}
                      </span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

export default TexturePreference;
